import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tabButton", "tabPanel"]
  static values = { activeTab: { type: String, default: "order" } }

  connect() {
    this.activate(this.activeTabValue)
  }

  switchTab(event) {
    const tab = event.currentTarget.dataset.tab
    this.activate(tab)
  }

  activate(tab) {
    this.activeTabValue = tab

    this.tabButtonTargets.forEach((btn) => {
      const active = btn.dataset.tab === tab
      btn.classList.toggle("active", active)
      btn.setAttribute("aria-selected", active ? "true" : "false")
    })

    this.tabPanelTargets.forEach((panel) => {
      const active = panel.dataset.tab === tab
      panel.hidden = !active
    })
  }
}
